// Fix swatch images for products without native color-pattern metafield
(function() {
  function initSwatchImages() {
    // Find all variant picker forms with swatches
    document.querySelectorAll('variant-picker, swatches-variant-picker-component').forEach(function(picker) {
      // Get variant data from the page's JSON
      var scripts = document.querySelectorAll('script[type="application/json"]');
      var variants = [];
      scripts.forEach(function(s) {
        try {
          var data = JSON.parse(s.textContent);
          if (data && data.variants && Array.isArray(data.variants)) {
            variants = data.variants;
          }
        } catch(e) {}
      });

      if (!variants.length) return;

      // Build a map of option value -> image src
      var imageMap = {};
      variants.forEach(function(v) {
        if (v.option1 && v.featured_image && v.featured_image.src) {
          imageMap[v.option1] = 'https:' + v.featured_image.src;
        }
      });

      // Find swatch elements and set their backgrounds
      picker.querySelectorAll('.variant-option__button-label--has-swatch .swatch').forEach(function(swatch) {
        // Find the associated input to get the value
        var label = swatch.closest('label');
        if (!label) return;
        var input = label.querySelector('input[type="radio"]');
        if (!input) return;
        var value = input.value;
        if (imageMap[value] && swatch.classList.contains('swatch--unavailable')) {
          swatch.style.setProperty('--swatch-background', 'url(' + imageMap[value] + ')');
          swatch.classList.remove('swatch--unavailable');
          swatch.classList.add('swatch--variant-image');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatchImages);
  } else {
    initSwatchImages();
  }
})();
